export const Color = {
  PRIMARY: '#ffc907',
  SECONDARY: '#20232a',

  GREEN: '#259423',
  PALE_GREEN: '#a6ed98',
  RED: '#e74343',
}
